import styled from 'styled-components';

import { MinBreakpointV2 } from '@xemplo/style-constants';

export const PromptFooter = styled.div`
  padding: 32px;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
  &.extended {
    @media ${MinBreakpointV2.medium} {
      flex-direction: row-reverse;
    }
  }

  &.hasOnlyTertiary {
    gap: 0;
  }
`;

export const PrimarySecondaryContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row-reverse;
  justify-content: center;
  gap: 16px;

  & > button {
    flex-grow: 1;
    max-width: 50%;
    min-width: 50%;
    @media ${MinBreakpointV2.medium} {
      min-width: 0;
    }
  }

  &.extended {
    @media ${MinBreakpointV2.medium} {
      justify-content: stretch;
      min-width: 50%;
      & > button {
        flex-grow: 0;
        min-width: 120px;
      }
    }
  }

  &.hasPrimaryOrSecondary button {
    max-width: 100%;
  }
`;

export const TertiaryContainer = styled.div`
  display: flex;
  gap: 16px;
  &.extended {
    @media ${MinBreakpointV2.medium} {
      width: 50%;
    }
  }
`;
